import { EventService } from './../../../pages/events/events.service';
import { Component, OnInit } from "@angular/core";
import { AuthenticationService } from "src/app/services/authentication.service";
import { ProfileService } from "src/app/pages/profile/profile.service";
import { CommunityService } from "src/app/pages/communities/communities.service";

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.scss"],
})
export class SidebarComponent implements OnInit {
  myProfile: any;
  searchFriend: string;
  searchCommunity: string;
  searchEvent: string;
  friends: any[] = [];
  communities: any[] = [];
  events: any[] = [];

  constructor(
    private authService: AuthenticationService,
    private profileService: ProfileService,
    private communitiesService: CommunityService,
    private eventService: EventService
  ) {}

  ngOnInit() {
    this.myProfile = this.authService.getLocalProfile();
    this.getFriends();

    this.profileService.friendsUpdated.subscribe((x) => {
      this.getFriends();
    });

    this.getCommunities();
    this.getEvents();
  }

  getCommunities() {
    this.communitiesService
      .getJoinedCommunities(this.myProfile.id)
      .subscribe((response) => {
        this.communities = response;
      });
  }

  getEvents() {
    this.eventService
      .getJoinedEvents(this.myProfile.id)
      .subscribe((response) => {
        this.events = response;
      });
  }

  getFriends() {
    this.profileService
      .getUserFriends(this.myProfile.id)
      .subscribe((response) => {
        this.friends = response;
      });
  }

  sendMessageToFriend(profile) {}
}
